export const WIDGET_TYPES_IDS = { 
    COMPUTE_EVENT: '38'
}